export const sparePartActions = {
  deleteBuyplanItem: "DELETE_SPARE_PART_BUYPLAN_ITEM",
  deleteBuyplanItemSuccess: "DELETE_SPARE_PART_BUYPLAN_ITEM_SUCCESS",
  deleteBuyplanItemFailure: "DELETE_SPARE_PART_BUYPLAN_ITEM_FAILURE",
  
  fetchParentProducts: "FETCH_PARENT_PRODUCTS",
  fetchParentProductsSuccess: "FETCH_PARENT_PRODUCTS_SUCCESS",
  fetchParentProductsFailure: "FETCH_PARENT_PRODUCTS_FAILURE",

  bulkRemoveItems: "BULK_REMOVE_SPARE_PART_ITEMS",
  bulkRemoveItemsSuccess: "BULK_REMOVE_SPARE_PART_ITEMS_SUCCESS",
  bulkRemoveItemsFailure: "BULK_REMOVE_SPARE_PART_ITEMS_FAILURE",
};

export const deleteBuyplanItem = (buyplanId, itemId) => {
  return {
    type: sparePartActions.deleteBuyplanItem,
    payload: {
      buyplanId,
      itemId
    }
  };
};

export const fetchParentProducts = (buyplanId, bpsbId, brandId) => {
  return {
    type: sparePartActions.fetchParentProducts,
    payload: {
      buyplanId,
      bpsbId,
      brandId
    }
  };
};

export const bulkRemoveItems = (releaseId, buyplanId, warehouseId, filters) => {
  return {
    type: sparePartActions.bulkRemoveItems,
    payload: {
      releaseId,
      buyplanId,
      warehouseId,
      filters
    }
  };
};
